import React from 'react';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export default function QuestionNotFound({
  assessmentId,
  surveyId,
}: {
  assessmentId?: string | number;
  surveyId?: string | number;
}) {
  const theme = useTheme();
  const rootPath =
    assessmentId && surveyId
      ? `/assessment/${assessmentId}/questionnaire/${surveyId}`
      : '/profile';

  return (
    <Container maxWidth="sm">
      <Typography mt={40} variant="h4" color={theme.palette.customThemeColors?.darkGrey}>
        Question Not Found
      </Typography>

      <Typography variant="body1" color="text.secondary" mt={1}>
        The question you are trying to access does not exist.
      </Typography>

      <Link href={rootPath}>
        <Typography variant="body1" mt={2}>
          Back to {assessmentId && surveyId ? 'Assessment' : 'Home'}
        </Typography>
      </Link>
    </Container>
  );
}